module.exports = __webpack_public_path__ + "static/img/yf_04.0b9aac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yf/yf_04.jpg
// module id = 1HVD
// module chunks = 1